import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams, HttpClientModule} from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { Body } from '@angular/http/src/body';

declare function require(url: string);

//const conf = require('assets/appconf.json');

@Injectable({
    providedIn: 'root'
})
export class WsGam {

    private gamUrl = "https://appconexao.gam.com.br:8200/api/v1";
    private headers = new HttpHeaders();
    private params = new HttpParams();

    constructor(private http: HttpClient) {
        this.headers = this.headers.append('Authorization', 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwOTM0MzU5NDU5NDQiLCJuYW1lIjoiRmFybcOhY2lhcyBBc3NvY2lhZGFzIiwiaWF0IjoxNTc5MDI0NzYyLCJ1dWlkIjoiZWIwNWU1OTYtNWI1Yi00MjljLTk0NDEtMjI5OWJkNDM1YjI3In0.sYFNp_ctGGKr20zJw_4zBDMCTHCxZ6ZEQSbqOumgTPw');
        this.headers = this.headers.append('Content-Type', 'application/json');
        this.params = this.params.append('empresaUuid', 'eb05e596-5b5b-429c-9441-2299bd435b27');
        this.params = this.params.append('status', 'I');
    }

    public getFunction(funcao, parametro, server) {

        
        if (parametro === false) {
            return this.http.get(`${this[server]}/${funcao}`, {headers: this.headers})
                .pipe(
                    timeout(60000)
                );
        // }else if(typeof parametro == 'object'){
        //     return this.http.get(`${this[server]}/clientes`, {headers: this.headers, body: this.params});
        }else {
            return this.http.get(`${this[server]}/${funcao}/${parametro}`, {headers: this.headers})
                .pipe(
                    timeout(60000)
                );
        }
    }

    public setFunction(funcao, objeto, server) {
        const url = `${this[server]}/${funcao}`;
        return this.http
            .put(url, JSON.stringify(objeto), {headers: this.headers});
    }


}